import { useShopI18n } from '../../i18n'
import type { CheckoutAddressForm } from '../flow'
import { AddressFields } from './AddressFields'

type CheckoutAddressPanelProps = {
  disabled: boolean
  editingAddressId: string | null
  form: CheckoutAddressForm
  formIdPrefix: string
  onCancel: () => void
  onFieldChange: (field: keyof CheckoutAddressForm, value: string) => void
  onSubmit: () => void
  panelError: string
  validationByField: Map<string, string>
}

export const CheckoutAddressPanel = ({
  disabled,
  editingAddressId,
  form,
  formIdPrefix,
  onCancel,
  onFieldChange,
  onSubmit,
  panelError,
  validationByField,
}: CheckoutAddressPanelProps) => {
  const { t } = useShopI18n()

  return (
    <section className="space-y-3 rounded-xl border border-slate-200 bg-slate-50 p-3">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-600">
        {editingAddressId ? t('checkout.addressBook.panelEditTitle') : t('checkout.addressBook.panelAddTitle')}
      </p>
      <AddressFields
        formIdPrefix={formIdPrefix}
        form={form}
        onFieldChange={onFieldChange}
        validationByField={validationByField}
        disabled={disabled}
      />
      {panelError ? <p className="text-xs font-medium text-rose-700">{panelError}</p> : null}
      <div className="flex items-center justify-end gap-2">
        <button
          type="button"
          className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-500"
          onClick={onCancel}
          disabled={disabled}
        >
          {t('checkout.cta.cancel')}
        </button>
        <button
          type="button"
          className="rounded-lg bg-slate-900 px-3 py-2 text-xs font-semibold text-white hover:bg-slate-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-500"
          onClick={onSubmit}
          disabled={disabled}
        >
          {t('checkout.addressBook.saveAddress')}
        </button>
      </div>
    </section>
  )
}
